import React, { Component } from 'react';
import { connect } from 'react-redux';
import BetSlots from '../components/BetSlots';
import { Accordion, Card } from 'react-bootstrap';
import BetBar from '../components/BetBar';
import BetFooter from '../components/BetFooter';
import { getEvents } from "../actions/eventsAction";
import { windowResize } from '../utils';
import { $t } from '../utils/translate';
import Loader from '../components/Loader';
import { getMessages } from '../actions/messageActions';
class MultiMarketPage extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      ot: true,
      nog: true,
      ou: true
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      windowResize();
    }
  }

  componentDidMount() {
    document.title = "Multi Market";
    if (this.props.gamesList == '') {
      this.props.getEvents();
    }

    windowResize();
  }

  resizeFrame(){
    setTimeout(()=>{
      windowResize();
    },500)
  }

  render() {
    let multiMarkets = [];
    if(this.props.gamesList["multi-market"] !== undefined){
      let markets = this.props.gamesList["multi-market"];
      for(let m=0;m<markets.length;m++){
        let market_name = markets[m]['market_name'];
        if(!multiMarkets.includes(market_name)){multiMarkets.push(market_name);}
      }
    } 
   
    return (
      <div>
        <BetBar jackpot={{ name: "multi-market", link: "/" }} send />
        {this.props.gamesList !== '' ?
          <div>

            {multiMarkets.includes('1x2') &&
              <BetSlots  gameType="1x2" isMulti="true"/>
            }

            {multiMarkets.includes('numberofgoals') &&
              <BetSlots  gameType="numberofgoals" isMulti="true"/>
            }

            {multiMarkets.includes('oversunders') &&
              <BetSlots  gameType="oversunders" isMulti="true"/>
            }

          </div> :
          <div>
            {!this.props.noResults?            
              <Loader/>
            :
              <h4 className="text-center my-4">{$t('text_no_active_jacpots', 'default', this.props.messages)}</h4>
            }
          </div>
          }
        <BetFooter gameType="multi-market" />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    messages: state.messageReducer.messages,
    gamesList: state.eventsReducer.gamesList,
    noResults: state.eventsReducer.noResults,
    events: state.eventsReducer.events
  }
}

export default connect(mapStateToProps, { getEvents,getMessages })(MultiMarketPage);




// WEBPACK FOOTER //
// ./pages/multiMarketPage.js